// src/layouts/DashboardLayout.jsx
import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Stack,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import InfoIcon from "@mui/icons-material/Info";
import LogoutIcon from "@mui/icons-material/Logout";
import toast from "react-hot-toast";
import { signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";

export default function DashboardLayout({ children }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success("Logged out successfully");
      navigate("/login");
    } catch (e) {
      console.error("Logout failed:", e);
      toast.error("Logout failed");
    }
  };

  const NavButton = ({ label, icon, path }) => (
    <Button
      startIcon={icon}
      onClick={() => navigate(path)}
      color="inherit"
      sx={{
        textTransform: "none",
        fontWeight: 600,
        opacity: 0.9,
        "&:hover": { opacity: 1, backgroundColor: "rgba(0,0,0,0.05)" },
      }}
    >
      {label}
    </Button>
  );

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#fafafa" }}>
      {/* --- Top Navbar --- */}
      <AppBar
        position="sticky"
        color="inherit"
        elevation={1}
        sx={{
          borderBottom: "1px solid #e0e0e0",
          background: "#fff",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: "primary.main", cursor: "pointer" }}
              onClick={() => navigate("/")}
            >
              🎵 Only Believe Hymn Dashboard
            </Typography>

            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

            <NavButton label="All Hymns" icon={<MusicNoteIcon />} path="/" />
            <NavButton
              label="Authors"
              icon={<PeopleAltIcon />}
              path="/authors"
            />
            <NavButton label="Keys" icon={<VpnKeyIcon />} path="/keys" />
            <NavButton label="About Info" icon={<InfoIcon />} path="/about" />
          </Stack>

          <Button
            variant="outlined"
            color="error"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      {/* --- Main Content --- */}
      <Box
        component="main"
        sx={{
          px: { xs: 2, md: 4 },
          py: 3,
          maxWidth: "1400px",
          mx: "auto",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
